import React from 'react';
import '../less/payoneer.less';
import hero_img from '../img/payoneer/hero_img.png';
import attention_icon from '../img/wu/attention_icon.svg'
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import { ReactSVG } from 'react-svg';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';
import tariffsData from '../../../../../../API/transfers/payoneer/tariffs.json';
import { payoneer } from '../../../../../services/urls/urls';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'payoneer-new';

    const hero_data = {
      title: 'PAYONEER_NEW_HERO_TITLE',
      text: 'PAYONEER_NEW_HERO_TEXT',
      link: {
        text: "PAYONEER_NEW_HERO_BTN",
        onClick: () => window.open(payoneer, "_blank", "noopener,noreferrer"),
      }
    }

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="payoneer-new">
        <Hero
          data={hero_data}
          img={hero_img}
          className="transfers"
          page={page}
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <div className="top-info">
                <div className="container">
                  <div className="top-info__body">
                    <div className="top-info__top">
                      <div className="top-info__title">{this.l10n('PAYONEER_NEW_TOP_INFO_TOP_TITLE')}</div>
                      <div className="top-info__text">
                        <ul>
                          <li>{this.l10n('PAYONEER_NEW_TOP_INFO_TOP_TEXT')}</li>
                        </ul>
                      </div>
                    </div>
                    <div className="top-info__middle">
                      <div className="top-info__title">
                        <ReactSVG src={attention_icon} className="top-info__icon"/>
                        {this.l10n('PAYONEER_NEW_TOP_INFO_MIDDLE_TITLE')}
                      </div>
                      <div className="top-info__text"><b>{this.l10n('PAYONEER_NEW_TOP_INFO_MIDDLE_TEXT')}</b></div>
                    </div>
                    <div className="top-info__bottom">
                      <div className="top-info__title">{this.l10n('PAYONEER_NEW_TOP_INFO_BOTTOM_TITLE')}</div>
                      <div className="top-info__text">{this.l10n('PAYONEER_NEW_TOP_INFO_BOTTOM_TEXT')}</div>
                    </div>
                  </div>
                </div>
              </div>
              <TransferTableNew data={tariffsData} title={'PAYONEER_NEW_TARIFFS_TITLE'}/>
              <QuestionsAdminNew
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'PAYONEER_NEW_QUESTIONS_NEW'}
                page={page}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('PAYONEER_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('PAYONEER_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
      </div>
    );
}
